import React from "react";
import { SearchForPlanCellDrawer } from "./SearchForPlanCellDrawer";
import { PlanCellWithIndex } from "../data/plan";
import { computePlanCellCoordinatesFromPlanCellWithIndex } from "../utils/planUtils";

export function EditMealDrawer(props: {
  onClose: () => void;
  open: boolean;
  onSubmit: () => void;
  planCells: PlanCellWithIndex[];
}) {
  const planCell = props.planCells?.[0];
  const planCellCoordinates = planCell
    ? computePlanCellCoordinatesFromPlanCellWithIndex(planCell)
    : undefined;

  if (!planCellCoordinates) return null;

  return (
    <SearchForPlanCellDrawer
      onClose={props.onClose}
      onSubmit={() => {
        props.onSubmit();
        props.onClose();
      }}
      open={props.open}
      planCellCoordinates={planCellCoordinates}
      planMode="plan"
      hideSearch
    />
  );
}
